<template>
	<dialog-component custom-class="dialog-cookies-wrap">
		<p class="cookies-title">Настройки Cookie</p>
		<p class="cookies-description">Вы можете выбрать, какие cookie будут использоваться при работе сервиса</p>
		<div>
			<div class="cookies-item-wrap cookies-item-wrap--first">
				<div class="cookies-switcher-wrap">
					<p class="cookies-item-title">Технические cookie (обязательные)</p>
					<switcher-component :state="techCookie" :disabled="true" id="techCookie" />
				</div>
				<p class="cookies-item-description">
					Обеспечивают работу основных функций, авторизацию, стабильность и безопасность. Эти файлы необходимы для
					функционирования сервиса и всегда включены
				</p>
			</div>
			<div class="cookies-item-wrap">
				<div class="cookies-switcher-wrap">
					<p class="cookies-item-title">Аналитические cookie</p>
					<switcher-component
						@toggleSwitcher="toggleAnalyticalCookie"
						:state="analyticalCookies"
						id="analyticalCookies"
					/>
				</div>
				<p class="cookies-item-description">
					Позволяют получать обезличенную статистику и улучшать качество сервиса. Используются только при наличии вашего
					согласия
				</p>
			</div>
		</div>
		<div class="cookies-wrapper-btn">
			<base-button text="Принять" @click="accept" />
			<p class="cookies-link" @click="goBack">{{ needShowCookiesDialog ? 'Назад' : 'Закрыть' }}</p>
		</div>
	</dialog-component>
</template>

<script setup lang="ts">
import DialogComponent from '@/components/dialogs/DialogComponent.vue'
import BaseButton from '@/components/base/BaseButton.vue'
import SwitcherComponent from '@/components/ui/SwitcherComponent.vue'
import { useCookiesStore } from '@/stores/cookies'
import { computed } from 'vue'

const cookiesStore = useCookiesStore()

const techCookie = computed(() => cookiesStore.cookiesSetting.tech)
const analyticalCookies = computed(() => cookiesStore.cookiesSetting.analytics)
const needShowCookiesDialog = computed(() => cookiesStore.needShowCookiesDialog)

function accept() {
	cookiesStore.setCookiesDialogShown()
	cookiesStore.saveCookiesSettings()
	cookiesStore.hideCookiesSettings()
}

function toggleAnalyticalCookie() {
	cookiesStore.toggleAnalyticalCookies()
}

function goBack() {
	cookiesStore.resetCookiesSettings()
	cookiesStore.hideCookiesSettings()
	if (needShowCookiesDialog.value) {
		cookiesStore.checkAndShowCookiesDialog()
	}
}
</script>

<style lang="scss" scoped>
.cookies {
	text-align: center;
	&-link {
		color: var(--text-secondary);
		text-align: center;
		text-decoration: underline;
		text-underline-offset: 2px;
		cursor: pointer;
		@media (min-width: $screen-mobile) {
			&:hover {
				color: var(--text-secondary-hover);
			}
			&:active {
				color: var(--text-secondary-hover);
			}
		}
	}
	&-title {
		font: var(--font-heading);
		margin-bottom: 12px;
		text-align: center;
		@media (max-height: $small-height) {
			margin-bottom: 8px;
			font: var(--font-label);
		}
		@if $is-mts {
			color: var(--text-primary);
			font-feature-settings:
				'liga' off,
				'clig' off;
		}
	}
	&-description {
		font: var(--font-body-small);
		margin-bottom: 24px;
		max-width: 343px;
		text-align: center;
		color: var(--text-secondary);
		@media (max-height: $small-height) {
			margin-bottom: 12px;
			font: var(--font-caption);
		}
		@if $is-mts {
			font: var(--font-body-small);
			color: var(--text-secondary);
		}
	}
	&-wrapper-btn {
		width: 100%;
		margin: 24px 0 8px 0;
		@media (max-height: $small-height) {
			margin-top: 4px;
			font: var(--font-caption);
		}
		& > * {
			margin-bottom: 12px;
			@media (max-height: $small-height) {
				margin-bottom: 4px;
				max-height: 40px;
				font: var(--font-label);
			}
		}
		@if $is-mts {
			:deep(.btn) {
				background: var(--background-inverse);
			}
			:deep(.btn-text) {
				color: var(--text-inverse);
				text-align: center;
			}
		}
	}
	&-img {
		margin-bottom: 24px;
	}
	&-item-description {
		font: var(--font-body-small);
		color: var(--text-secondary);
		@media (max-height: $small-height) {
			margin-bottom: 8px;
			font: var(--font-caption);
		}
		@if $is-mts {
			font: var(--font-body-small);
			color: var(--text-secondary);
		}
	}
	&-item-title {
		font: var(--font-heading);
		max-width: 306px;
		width: 100%;
		@media (max-height: $small-height) {
			font: var(--font-body-small);
		}
		@if $is-mts {
			color: var(--text-primary);
			font-feature-settings:
				'liga' off,
				'clig' off;
		}
	}
	&-item-wrap {
		padding: 16px 0;
		@media (max-height: $small-height) {
			padding: 8px 0;
		}
		&--first {
			border-top: 1px solid var(--border-subtle);
			border-bottom: 1px solid var(--border-subtle);
		}
	}
	&-switcher-wrap {
		@include flex-space-between;
		width: 100%;
	}
}
</style>
